module.exports = __webpack_public_path__ + "static/media/regionsAndLicenses.6682927a.svg";